import { useContext } from 'react';
import {
  PaginationContext,
  PaginationContextValues,
} from '../providers/PaginationProvider';

export const usePaginationContext = (): PaginationContextValues => {
  return useContext(PaginationContext);
};
